export const getStatus = (status: number) => {
  if (status === 0) {
    return { label: 'new', variant: 'informative' };
  } else if (status === 1) {
    return { label: 'draft', variant: 'notice' };
  } else if (status === 2) {
    return { label: 'confirmed', variant: 'positive' };
  } else if (status === 3) {
    return { label: 'inProgress', variant: 'notice' };
  } else if (status === 4) {
    return { label: 'finalized', variant: 'positive' };
  } else {
    return { label: 'noStatus', variant: 'neutral' };
  }
};
